// src/locales/en/products.js
export const products = {
  // Page titles and navigation
  createNewProduct: 'Create New Product',
  addNewProductToInventory: 'Add a new product to your inventory',
  backToProducts: 'Back to Products',
  allProducts: 'All Products',
  addProduct: 'Add Product',
  editProduct: 'Edit Product',
  deleteProduct: 'Delete Product',
  duplicateProduct: 'Duplicate Product',
  viewDetails: 'View Details',
  
  // Product list page
  manageProductInventory: 'Manage your product inventory and catalog',
  loadingProducts: 'Loading Products',
  loadingProductsDesc: 'Please wait while we load your products...',
  unableToLoadProducts: 'Unable to Load Products',
  noProductsFound: 'No Products Found',
  noProductsFoundDesc: 'No products match your current search and filter criteria.',
  noProductsYet: 'No Products Yet',
  noProductsYetDesc: 'Start building your inventory by adding your first product.',
  addFirstProduct: 'Add First Product',
  priceOptions: 'price options',
  range: 'Range',
  noPrice: 'No Price',
  multiplePrices: 'Multiple Prices',
  priceRange: 'Price Range',
  lowestPrice: 'Lowest Price',
  highestPrice: 'Highest Price',
  startingFrom: 'Starting from',
  upTo: 'Up to',
  
  // Product list filters
  allTypes: 'All Types',
  allVisibility: 'All Visibility',
  allStatus: 'All Status',
  allCategories: 'All Categories',
  
  // Product list table headers
  productDetails: 'Product Details',
  noCategories: 'No categories',
  
  // Product list pagination
  show: 'Show',
  perPage: 'per page',
  showingRecords: 'Showing {{start}} to {{end}} of {{total}} results',
  firstPage: 'First Page',
  previousPage: 'Previous Page',
  nextPage: 'Next Page',
  lastPage: 'Last Page',
  
  // Product actions and confirmations
  confirmStatusChange: 'Are you sure you want to make "{{productName}}" {{action}}?',
  confirmDuplicate: 'Are you sure you want to duplicate "{{productName}}"?',
  confirmDelete: 'Are you sure you want to delete "{{productName}}"? This action cannot be undone.',
  statusUpdateSuccess: '"{{productName}}" has been made {{status}} successfully!',
  statusUpdateFailed: 'Failed to update product status. Please try again.',
  duplicateSuccess: '"{{productName}}" has been duplicated successfully!',
  duplicateFailed: 'Failed to duplicate product. Please try again.',
  deleteSuccess: '"{{productName}}" has been deleted successfully!',
  deleteFailed: 'Failed to delete product. Please try again.',
  
  // Product status actions
  makeDraft: 'Make Draft',
  makePublic: 'Make Public',
  
  // Loading states
  loadingData: 'Loading Data',
  loadingDataDesc: 'Please wait while we load the required data...',
  failedToLoadData: 'Failed to load required data. Please try again.',
  
  // Form tabs
  basicInfo: 'Basic Info',
  pricing: 'Pricing & Inventory',
  pricingInfo: 'Pricing Information',
  pricingInfoDesc: 'Set pricing and shop-specific information',
  pricingInfoEditDesc: 'Update pricing and shop-specific information',
  images: 'Images',
  variations: 'Variations',
  
  // Basic Information
  basicInformation: 'Basic Information',
  basicInformationDesc: 'Enter the basic details about your product',
  basicInformationEditDesc: 'Update the basic details about your product',
  productName: 'Product Name',
  productNamePlaceholder: 'Enter product name',
  printableName: 'Printable Name',
  printableNamePlaceholder: 'Name to print on waybills (optional)',
  printableNameHint: 'If set, this name is printed on waybill labels instead of the product name',
  nameRequired: 'Product name is required',
  
  productType: 'Product Type',
  productTypeShort: 'Type',
  productTypeRequired: 'Product type is required',
  simpleProduct: 'Simple Product',
  variableProduct: 'Variable Product (with variations)',
  simpleProductShort: 'Simple',
  variableProductShort: 'Variable',

  
  description: 'Description',
  descriptionPlaceholder: 'Enter product description (optional)',
  
  visibility: 'Visibility',
  visibilityRequired: 'Visibility is required',
  public: 'Public',
  draft: 'Draft',
  trash: 'Trash',
  
  brand: 'Brand',
  selectBrand: 'Select a brand (optional)',
  
  // Categories and Tags
  categories: 'Product Categories',
  categoriesShort: 'Categories',
  categoryRequired: 'Please select a category',
  chooseCategory: 'Choose a product category',
  
  tags: 'Tags',
  selectTags: 'Select Tags',
  searchTags: 'Search tags...',
  noTagsFound: 'No tags found',
  noTagsAvailable: 'No tags available',
  loadingTags: 'Loading tags...',
  productTags: 'Product Tags',
  selectProductTags: 'Select product tags',
  tagsSelected: '{{count}} tags selected',
  removeTag: 'Remove tag',
  
  // Pricing and Inventory
  pricingInventory: 'Pricing & Inventory',
  pricingInventoryDesc: 'Set pricing, inventory, and product dimensions',
  basicPricingInfo: 'Basic Pricing Information',
  basicPricingInfoDesc: 'Set basic pricing details. Shop pricing and inventory will be configured per variation.',
  
  buyingPrice: 'Buying/Cost Price',
  barcode: 'Barcode',
  barcodePlaceholder: 'Enter product barcode (optional)',
  
  weight: 'Weight',
  length: 'Length', 
  width: 'Width',
  height: 'Height',
  
  shopPricingInventory: 'Shop-Specific Pricing',
  shopPricingInventoryDesc: 'Set different prices and stock levels for each shop',
  shopPricingInventoryDescSelect: 'Select shops and set pricing for each shop',
  shopPricing: 'Shop Pricing',
  shopPricingDesc: 'Set pricing for each shop where this product will be sold',
  salesPrice: 'Sales Price',
  salesPriceRequired: 'Sales price is required',
  dropshippingPrice: 'Dropshipping Price',
  dropshippingPriceRequired: 'Dropshipping price is required for dropshipper shops',
  dropshipperPricing: 'Dropshipper Pricing',
  stock: 'Stock',
  stockRequired: 'Stock quantity is required',
  
  // Opening Stock
  openingStock: 'Opening Stock',
  openingStockDesc: 'Set the initial stock quantity for each warehouse',
  warehouseStock: 'Warehouse Stock',
  openingStockRequired: 'Opening stock is required',
  openingStockMinimum: 'Opening stock must be 0 or greater',
  
  // Variations
  productVariations: 'Product Variations',
  productVariationsDesc: 'Configure pricing and inventory for each variation',
  productVariationsDescFull: 'Configure pricing and inventory for each variation. Each variation can have different pricing across shops and different stock levels in warehouses.',
  variation: 'Variation',
  sku: 'SKU',
  skuPlaceholder: 'Enter SKU (optional)',
  skuVariationPlaceholder: 'Enter variation SKU',
  price: 'Price',
  variationPriceRequired: 'Variation price is required',
  variationStockRequired: 'Variation stock is required',
  costPrice: 'Cost Price',
  variationImage: 'Variation Image',
  editModeVariationsNote: 'Changes to variations will preserve existing IDs and relationships.',
  
  // Variations UI
  variationsGenerated: '{{count}} Variations Generated',
  configureVariations: 'Configure each variation below:',
  regenerate: 'Regenerate',
  removeSelected: 'Remove Selected ({{count}})',
  bulkActions: 'Bulk Actions',
  variationsSelected: '{{selected}} of {{total}} selected',
  variationNumber: 'Variation #{{number}}',
  expand: 'Expand',
  collapse: 'Collapse',
  edit: 'Edit',
  
  // Bulk Actions
  bulkActionsTitle: 'Bulk Actions',
  bulkActionsDesc: 'Apply changes to {{count}} selected variations',
  shopAssignments: 'Shop Assignments',
  basicFields: 'Basic Fields',
  cancel: 'Cancel',
  applyToSelected: 'Apply to Selected',
  bulkActionsApplied: 'Bulk actions applied successfully',
  bulkActionsError: 'Please select variations to apply bulk actions',
  productsSelected: '{{count}} products selected',
  deleteSelected: 'Delete Selected ({{count}})',
  confirmBulkDelete: 'Are you sure you want to delete {{count}} products? This action cannot be undone.',
  bulkDeleteSuccess: '{{count}} products have been deleted successfully!',
  bulkDeleteFailed: 'Failed to delete some products. Please try again.',
  
  // Variations Validation
  noVariationsAvailable: 'No Variations Available',
  noVariationsMessage: 'To create variations, please:',
  goToAttributesStep1: 'Go to the',
  goToAttributesStep2: 'tab',
  goToAttributesStep3: 'Add product attributes',
  goToAttributesStep4: 'Select attribute values',
  goToAttributesStep5: 'Enable "Used for variations" for the attributes you want to use',
  goToAttributes: 'Go to Attributes',
  noVariationsGenerated: 'No Variations Generated',
  noVariationsGeneratedDesc: 'Variations will be automatically generated based on your attribute selections.',
  atLeastOneVariationRequired: 'At least one variation is required',
  atLeastOneShopRequired: 'At least one shop must be enabled with a sales price',
  skuValidationInProgress: 'SKU validation in progress...',
  skuAlreadyInUse: 'This SKU is already in use',
  
  // Attributes
  attributes: 'Product Attributes',
  selectAttributes: 'Select Attributes',
  attributesRequiredForVariable: 'At least one attribute is required for variable products',
  attributesVariableDesc: 'Selected attributes will be used to generate product variations',
  attributesDesc: 'Select attributes that apply to this product',
  attributesVariableEditDesc: 'Selected attributes will be used to generate product variations. Changes will affect existing variations.',
  attributesEditDesc: 'Select attributes that describe this product.',
  variableProductAttributesRequired: 'Variable products require at least one attribute for variations.',
  variationAttributesInfo: 'Attributes marked as "Used for variations" will generate product variations.',
  variationAttributesInfo2: 'Make sure to select attribute values to create the variations you need.',
  changesWillUpdateVariations: 'Changes to attributes may affect existing product variations.',
  
  // Images
  productImages: 'Product Images',
  productImagesDesc: 'Upload images to showcase your product',
  productImagesRecommendation: 'Upload your recommendations for product images.',
  editModeImageNote: 'You can replace existing images or add new ones. Changes will be saved when you update the product.',
  editModeInstructions: 'Replace existing images by clicking on them, or add new images to empty slots.',
  
  mainImage: 'Main Product Image',
  uploadMainImage: 'Upload Main Image',
  uploadImages: 'Upload Images',
  clickToUploadMainImage: 'Click to upload main image',
  imageFormats: 'PNG, JPG, JPEG, WEBP up to 5MB',
  invalidImageFormat: 'Invalid image format. Please use PNG, JPG, JPEG, or WEBP',
  imageTooLarge: 'Image file is too large. Maximum size is 5MB',
  
  galleryImages: 'Gallery Images',
  galleryImagesDesc: 'Upload additional images to show different angles or features',
  addGalleryImages: 'Add Gallery Images',
  invalidGalleryImages: 'One or more gallery images are invalid or too large',
  setAsMainImage: 'Set as main image',
  replaceImage: 'Replace Image',
  revertImage: 'Revert Image',
  removeImage: 'Remove Image',
  mainImageBadge: 'MAIN',
  modified: 'Modified',
  dragDropInstructions: 'Drag and drop or select files to upload.',
  maxImagesNote: 'Maximum {{max}} images are allowed.',
  
  // Form actions
  createProduct: 'Create Product',
  updateProduct: 'Update Product',
  productCreatedSuccess: 'Product "{{productName}}" created successfully!',
  productUpdated: 'Product updated successfully',
  failedToCreateProduct: 'Failed to create product. Please try again.',
  failedToUpdateProduct: 'Failed to update product. Please try again.',
  failedToLoadProduct: 'Failed to load product. Please try again.',
  
  // Common terms used throughout
  required: 'Required',
  optional: 'Optional',
  selectOption: 'Select an option',
  
  // Error messages
  someFieldsRequired: 'Please fill in all required fields',
  invalidPriceValue: 'Please enter a valid price',
  invalidStockValue: 'Please enter a valid stock quantity',
  stockMinZero: 'Stock must be 0 or greater',
  salesPriceRequiredEnabled: 'Sales price is required for enabled shops',
  
  // Success messages
  productSaved: 'Product saved successfully',
  productDeleted: 'Product deleted successfully',
  
  // Validation messages
  priceMinimum: 'Price must be greater than 0',
  stockMinimum: 'Stock must be 0 or greater',
  weightMinimum: 'Weight must be greater than 0',
  dimensionMinimum: 'Dimensions must be greater than 0',
  
  // Product status labels
  active: 'Active',
  inactive: 'Inactive',
  inStock: 'In Stock',
  outOfStock: 'Out of Stock',
  lowStock: 'Low Stock',
  
  // Shop integration
  availableInShops: 'Available in Shops',
  notAvailableInAnyShop: 'This product is not available in any shop',
  shopSpecificPricing: 'Shop-specific pricing enabled',
  
  // Attribute and variation helpers
  noAttributesSelected: 'No attributes selected',
  variationsWillBeGenerated: 'Variations will be automatically generated based on selected attributes',
  variationCount: '{{count}} variations will be created',
  
  // Image upload helpers
  dragDropImages: 'Drag and drop images here, or click to select',
  // maxImagesNote: 'You can upload up to 5 images',
  imageUploadProgress: 'Uploading images...',
  imageUploadComplete: 'Images uploaded successfully',
  imageUploadFailed: 'Failed to upload some images',
  
  // Bulk actions (for future use)
  selectAll: 'Select All',
  deselectAll: 'Deselect All',
  bulkEdit: 'Bulk Edit',
  bulkDelete: 'Bulk Delete',
  
  // Filters and search
  searchProducts: 'Search products...',
  filterByCategory: 'Filter by Category',
  filterByBrand: 'Filter by Brand',
  filterByStatus: 'Filter by Status',
  sortByName: 'Sort by Name',
  sortByPrice: 'Sort by Price',
  sortByStock: 'Sort by Stock',
  sortByDate: 'Sort by Date',
  warehouse: 'Warehouse',
  allWarehouses: 'All Warehouses',
  
  // General information
  generalInformation: 'General Information',
  pricingInformation: 'Pricing Information',
  inventoryInformation: 'Inventory Information',
  shippingInformation: 'Shipping Information',
  
  // Import/Export
  importProducts: 'Import Products',
  exportProducts: 'Export Products',
  downloadTemplate: 'Download Template',
  uploadFile: 'Upload File',

  // Bulk Import
  bulkImportProducts: 'Bulk Import',
  bulkImportProductsTitle: 'Bulk Import Products',
  bulkImportProductsDesc: 'Upload an Excel sheet to create or update many products at once',
  columnMapping: 'Column Mapping',
  selectShopsStep: 'Select Shops',
  uploadFileStep: 'Upload File',
  validateProducts: 'Validate Products',
  submitProducts: 'Submit Products',
  submitValidProducts: 'Submit {{count}} Valid Products',
  clearAll: 'Clear All',
  retryValidation: 'Retry Validation',
  importComplete: 'Import Complete!',
  successfullyImported: 'Successfully Imported',
  importMoreProducts: 'Import More Products',
  viewProducts: 'View Products',
  failedRows: 'Failed Rows:',
  validRows: 'Valid Rows',
  invalidRows: 'Invalid Rows',
  totalRows: 'Total Rows',
  totalSubmitted: 'Total Submitted',
  validationResults: 'Validation Results',
  
  // Advanced features
  enableTracking: 'Enable Inventory Tracking',
  trackingEnabled: 'Inventory tracking is enabled for this product',
  trackingDisabled: 'Inventory tracking is disabled for this product',
  
  digitalProduct: 'Digital Product',
  physicalProduct: 'Physical Product',
  downloadableProduct: 'Downloadable Product',
  
  // SEO and marketing
  seoTitle: 'SEO Title',
  seoDescription: 'SEO Description',
  metaKeywords: 'Meta Keywords',
  
  // Related products
  relatedProducts: 'Related Products',
  crossSells: 'Cross-sell Products',
  upSells: 'Up-sell Products',
  
  // Reviews and ratings
  customerReviews: 'Customer Reviews',
  averageRating: 'Average Rating',
  totalReviews: 'Total Reviews',
  
  // Inventory alerts
  lowStockAlert: 'Low Stock Alert',
  outOfStockAlert: 'Out of Stock Alert',
  setAlertThreshold: 'Set Alert Threshold',
  
  // Product history
  productHistory: 'Product History',
  priceHistory: 'Price History',
  stockHistory: 'Stock History',
  lastUpdated: 'Last Updated',
  createdDate: 'Created Date',
  
  // Warnings and confirmations
  deleteProductWarning: 'Are you sure you want to delete this product? This action cannot be undone.',
  unsavedChanges: 'You have unsaved changes. Are you sure you want to leave?',
  discardChanges: 'Discard Changes',
  saveChanges: 'Save Changes',
  
  // Form sections that might be added later
  advancedOptions: 'Advanced Options',
  shippingSettings: 'Shipping Settings',
  taxSettings: 'Tax Settings',
  customFields: 'Custom Fields',
  
  // Product performance metrics
  totalSales: 'Total Sales',
  revenue: 'Revenue',
  profitMargin: 'Profit Margin',
  popularityScore: 'Popularity Score',

  configureVariationsEdit: 'Configure pricing and inventory for each variation. Changes will preserve existing relationships.',
  editModeStockNotice: 'Stock quantities are managed separately and not updated through product editing.',
  currentImage: 'Current Image',
  newImage: 'New Image',
  currentImageWillBeDeleted: 'Current image will be deleted',
  undoDelete: 'Undo',
  chooseImageFile: 'Choose an image file to upload for this variation',
  
  // Additional helpful translations
  existingVariation: 'Existing Variation',
  newVariation: 'New Variation',
  variationUpdated: 'Updated',
  variationCreated: 'New',
  
  // Bulk actions translations
  applyingBulkActions: 'Applying bulk actions...',
  bulkActionsCompleted: 'Bulk actions completed successfully',
  
  // Image management
  replaceCurrentImage: 'Replace current image',
  uploadNewImage: 'Upload new image',
  removeCurrentImage: 'Remove current image',
  keepCurrentImage: 'Keep current image',
  
  // Validation messages
  variationSkuInUse: 'This variation SKU is already in use',
  validatingVariationSku: 'Validating variation SKU...',
  
  // Status indicators
  hasChanges: 'Has Changes',
  noChanges: 'No Changes',
  unsavedChanges: 'Unsaved Changes',

  // Product Details Page
  productNotFound: 'Product Not Found',
  productNotFoundDesc: 'The product you\'re looking for doesn\'t exist or has been removed.',
  viewProduct: 'View Product',
  productInformation: 'Product Information',
  shopPricingAndStock: 'Shop Pricing & Stock',
  variationDetails: 'Variation Details',
  stockByWarehouse: 'Stock by Warehouse',
  priceRangeSummary: 'Price Range Summary',
  variationsList: 'Variations List',
  expandVariation: 'Expand Variation',
  collapseVariation: 'Collapse Variation',
  noShopPricing: 'No shop pricing configured',
  noStockInformation: 'No stock information available',
  noVariationsConfigured: 'No variations configured',

  // Quantity Offers
  manageOffers: 'Manage Offers',
  offersTitle: 'Quantity-Based Offers',
  addOffer: 'Add Offer',
  saveOffers: 'Save Offers',
  noOffersYet: 'No offers configured yet',
  offerQuantity: 'Quantity',
  offerCriteria: 'Condition',
  offerUnitPrice: 'Unit Price',
  offerDeliveryOverride: 'Override Delivery Charge',
  criteriaEqual: 'Equal to',
  criteriaGte: 'Greater than or equal',

  // Bundle products
  bundleProduct: 'Bundle Product',
  bundleProductShort: 'Bundle',
  bundles: 'Bundles',
  bundleTab: 'Bundle',
  bundleComponents: 'Bundle Components',
  addComponent: 'Add Component',
  searchComponents: 'Search products to add...',
  componentQty: 'Qty',
  component: 'Component',
  unitValue: 'Unit Value',
  lineDiscount: 'Discount',
  lineTotal: 'Line Total',
  bundlePrice: 'Bundle Price',
  regularTotal: 'Regular Total',
  saving: 'Saving',
  free: 'FREE',
  componentNotAssigned: '{product} is not assigned to this shop',
  typeLocked: 'Bundle type cannot be changed after creation',
  itemsCount: '{count} items',
  noComponentsYet: 'No components added yet. Search above to add products.',
  bundleShopPricing: 'Shop Pricing',
  bulkSetValue: 'Set unit value',
  bulkSetDiscountAmount: 'Set discount amount',
  bulkSetDiscountPercent: 'Set discount %',
  bulkMakeFree: 'Make free (100%)',
  bulkFillFromShopPrice: 'Fill from shop price',
  bulkCopyShop: 'Copy from shop',
  copyFromShop: 'Source shop',
  applyBulk: 'Apply',
  selectedCount: '{count} selected',
  bundleComponentsRequired: 'Add at least one component to the bundle',
  bundleShopRequired: 'Enable at least one shop for the bundle',
  bundleQtyInvalid: 'Component quantity must be greater than 0',
  bundleValueInvalid: 'Unit value must be 0 or more',
  bundleDiscountInvalid: 'Discount must be between 0 and the line value',
  totalWeight: 'Total Weight',
  availableStock: 'Available Stock',
  noSku: 'No SKU',
  notAssigned: 'Not assigned',
  componentStock: 'Component Stock',
};